import { Input } from '@/components/ui/input';
import type { ShippingFields } from '@/lib/ordering';

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label className="block">
      <span className="mb-1 block text-[10.5px] font-medium uppercase tracking-wide text-subtle">{label}</span>
      {children}
    </label>
  );
}

// Shipping + contact form shared by the Place Order and Sample Order dialogs.
export function ShippingAddressForm({
  value,
  onChange,
  email,
  onEmailChange,
  emailLabel = 'Email',
}: {
  value: ShippingFields;
  onChange: (v: ShippingFields) => void;
  email: string;
  onEmailChange: (v: string) => void;
  emailLabel?: string;
}) {
  const set = (patch: Partial<ShippingFields>) => onChange({ ...value, ...patch });
  return (
    <div className="space-y-2">
      <Field label={emailLabel}>
        <Input type="email" value={email} onChange={(e) => onEmailChange(e.target.value)} placeholder="customer@example.com" />
      </Field>
      <div className="grid grid-cols-2 gap-2">
        <Field label="First name *">
          <Input value={value.firstName} onChange={(e) => set({ firstName: e.target.value })} placeholder="John" />
        </Field>
        <Field label="Last name *">
          <Input value={value.lastName} onChange={(e) => set({ lastName: e.target.value })} placeholder="Doe" />
        </Field>
      </div>
      <Field label="Company (optional)">
        <Input value={value.company} onChange={(e) => set({ company: e.target.value })} placeholder="Company name" />
      </Field>
      <Field label="Address line 1 *">
        <Input value={value.address1} onChange={(e) => set({ address1: e.target.value })} placeholder="123 Main St" />
      </Field>
      <Field label="Address line 2 (optional)">
        <Input value={value.address2} onChange={(e) => set({ address2: e.target.value })} placeholder="Suite 100" />
      </Field>
      <div className="grid grid-cols-[2fr_1fr] gap-2">
        <Field label="City *">
          <Input value={value.city} onChange={(e) => set({ city: e.target.value })} placeholder="City" />
        </Field>
        <Field label="State *">
          <Input value={value.state} maxLength={2} className="uppercase" onChange={(e) => set({ state: e.target.value.toUpperCase() })} placeholder="TX" />
        </Field>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Field label="ZIP *">
          <Input value={value.zip} onChange={(e) => set({ zip: e.target.value })} placeholder="78701" />
        </Field>
        <Field label="Country">
          <select
            value={value.country}
            onChange={(e) => set({ country: e.target.value })}
            className="h-8 w-full rounded-sm border border-border bg-bg px-2 text-[12px] focus:outline-none focus:ring-1 focus:ring-primary"
          >
            <option value="US">United States</option>
            <option value="CA">Canada</option>
          </select>
        </Field>
      </div>
      <Field label="Phone (optional)">
        <Input type="tel" value={value.phone} onChange={(e) => set({ phone: e.target.value })} placeholder="(555) 123-4567" />
      </Field>
    </div>
  );
}
